import React from 'react';
import { Typography } from '~/UIKit';
import { EventImage } from './';
import { EventPageInformationStyles } from './EventPageInformation.styles';
import { useEventPageInformation } from './useEventPageInformation';
import { Spots, Trainer, Location } from '~/Components/Icons';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

type EventPageInformationProps = {
  additionalInfo?: JSX.Element;
};
export const EventPageInformation = ({ additionalInfo }: EventPageInformationProps) => {
  const {
    eventImage,
    eventName,
    trainerString,
    locationName,
    totalBookings,
    totalSeats,
    cancelled,
  } = useEventPageInformation();
  const { t } = useTranslation();

  const { classes } = EventPageInformationStyles();

  return (
    <div className={classes.header}>
      <EventImage imagePath={eventImage} />
      <div className={classes.infoWrapper}>
        <Typography variant="h4" className={classes.EventPageInformationTitle}>
          <span className={classes.EventPageInfoTextWrapper}>
            <Spots />
            {cancelled ? t('app.event.cancelled') : `${totalBookings}/${totalSeats}`}
          </span>
          <span
            className={classNames(
              classes.EventPageInfoTextWrapper,
              classes.EventPageInfoLocationWrapper,
            )}
          >
            <Location />
            {locationName}
          </span>
          <span className={classes.EventPageInfoTextWrapper}>
            <Trainer />
            {trainerString}
          </span>
        </Typography>
        <div className={classes.EventPageTitle}>
          <Typography className={classes.title}>
            {additionalInfo ? `${eventName} | ` : eventName}
          </Typography>
          {!!additionalInfo && additionalInfo}
        </div>
      </div>
    </div>
  );
};
